import { FAQ_SL } from "@/content/faqData";
import { legalSl } from "./legal-sl";
import { propertyChecksSl } from "./property-checks-sl";
import { supportingDocumentsSl } from "./supporting-documents";

export const sl = {
  common: {
    error: "Napaka",
    cancel: "Prekliči",
    send: "Pošlji",
    sending: "Pošiljam...",
    or: "Ali",
    and: "in",
    aptNo: "Št.",
    aptNoTitle: "Številka stanovanja",
    toggleMenu: "Odpri meni",
    skipToContent: "Preskoči na vsebino",
    language: "Jezik",
  },
  announcement: {
    text: "Preizkusite brezplačno — predogled poročila za vaš naslov.",
    cta: "Začnite zdaj",
    dismiss: "Zapri obvestilo",
  },
  header: {
    features: "Funkcionalnosti",
    howItWorks: "Kako deluje",
    pricing: "Cenik",
    dashboard: "Nadzorna plošča",
    adminDashboard: "Admin plošča",
    signOut: "Odjava",
    login: "Prijava",
    register: "Registracija",
  },
  brand: {
    "startLabel": "Začnite z naslovom nepremičnine",
    "searchCta": "Nadaljujte",
    "freeNote": "Brezplačen predogled po potrditvi e-pošte.",
    "sampleLabel": "Primer poročila",
    "sampleNote": "Izmišljeni podatki · prikaz vsebine",
    "sampleType": "Stanovanje · Ljubljana",
    "estimate": "Informativna ocena vrednosti",
    "uncertainty": "Razpon ocene · prikaz negotovosti",
    "sources": "Podlaga za oceno",
    "sourceSales": "Realizirane prodaje",
    "sourceRegistry": "Evidenca GURS",
    "sourceListings": "Primerljivi oglasi",
    "checks": "Kaj še preveriti",
    "checkTitle": "Zemljiškoknjižno stanje",
    "checkNote": "Lastništvo in bremena preverite pred podpisom.",
    "sourceTitle": "Podatki, ki odločitev postavijo na trdna tla.",
    "sourceDescription": "Javne evidence in tržni podatki, povezani v razumljivo celoto. Razpoložljivost je odvisna od nepremičnine.",
    "sourceGurs": "Podatki o stavbi, delu stavbe in zemljišču",
    "sourceEtn": "Zabeležene prodaje in gibanje cen",
    "sourceZk": "Lastništvo in bremena, kadar je izpisek pridobljen",
    "sourceAds": "Kontekst aktualnih oglaševanih cen",
    "sampleCta": "Poglejte, kaj vsebuje poročilo",
    "sampleDisclaimer": "Ponazoritev z izmišljenimi podatki, ne analiza tega naslova.",
    "featuresEyebrow": "Vsebina poročila",
    "featuresTitle": "Od podatkov do jasnejše slike.",
    "featuresDescription": "Poročilo poveže oceno z njeno podlago in pokaže vprašanja, ki jih je treba še razrešiti.",
    "processTitle": "Od naslova do naslednjega koraka.",
    "illustration": "Ponazoritev razlike",
    "included": "V vsakem celotnem poročilu",
    "previewEyebrow": "Oglejte si vsebino",
    "previewTitle": "Poročilo, ki ga lahko uporabite.",
    "previewDescription": "Shranite ga, delite s partnerjem ali ga vzemite na pogovor s strokovnjakom. Pomembni podatki, podlage in naslednji koraki ostanejo skupaj.",
    "previewPoints": [
      "Jasno ločena ocena in njena negotovost",
      "Sledljive podlage in primerljive prodaje",
      "Odprta tveganja in koraki pred podpisom"
    ],
    "previewLanguage": "Vzorec poročila je v slovenščini.",
    "featureItems": [
      {
        "title": "Podatki iz evidenc GURS",
        "description": "Površine, leto gradnje, podatki o stavbi in zemljišču ter posplošena vrednost."
      },
      {
        "title": "Realizirane prodaje",
        "description": "Primerljivi zabeleženi posli v okolici, njihove cene in čas sklenitve."
      },
      {
        "title": "Lokacija in okolica",
        "description": "Umestitev nepremičnine, dostopnost in lokacijski dejavniki."
      },
      {
        "title": "Ocena z razlago",
        "description": "Informativna ocena vrednosti z razponom negotovosti in pojasnjeno podlago."
      },
      {
        "title": "Tveganja in naslednji koraki",
        "description": "Jasno označene odprte preverbe ter argumenti za pogovor o ceni."
      },
      {
        "title": "Pregleden PDF",
        "description": "Poročilo za shranjevanje, deljenje ali posvet s strokovnjakom."
      }
    ]
  },
  hero: {
    badgeGurs: "Uradni podatki GURS",
    badgeValidity: "Krediti veljajo 1 leto",
    badgeReports: "100+ generiranih poročil",
    eyebrow: "Poročila o nepremičninah v Sloveniji",
    titleLead: "Najprej dejstva.",
    titleHighlight: "Potem odločitev.",
    subtitle:
      "Razumite ceno nepremičnine, primerjajte realizirane prodaje in preverite odprta vprašanja. Vse v enem preglednem poročilu.",
    tagline: "Neodvisen pregled javnih evidenc in tržnih podatkov.",
    featureOfficialTitle: "Uradni podatki",
    featureOfficialDesc:
      "Neposreden dostop do najnovejših uradnih ETN, GURS in zemljeknjižnih podatkov.",
    featureMarketTitle: "Tržna analiza in primerjave",
    featureMarketDesc:
      "Primerjava s preteklimi prodajami in trenutnimi oglasi v vaši okolici.",
    featureAiTitle: "Argumenti za pogajanja",
    featureAiDesc:
      "PDF z navodili kako se pogajati za nižjo ceno in katera tveganja preveriti pred podpisom.",
    ctaOrder: "Naročite podrobno poročilo",
    ctaPreview: "Oglejte si primer",
  },
  propertyNextStep: {
    "eyebrow": "Izbrana nepremičnina",
    "edit": "Spremeni naslov",
    "previewTitle": "Začnite z brezplačnim predogledom",
    "previewNote": "Oglejte si podatke GURS in povzetek ugotovitev za ta naslov. Našo oceno vrednosti in celotno analizo odklenete s plačljivim kreditom.",
    "noCard": "En predogled po potrditvi e-pošte · brez plačilne kartice",
    "signedInTitle": "Nadaljujte s tem naslovom",
    "signedInNote": "Naslov vas čaka na nadzorni plošči. Tam uporabite razpoložljive kredite za predogled ali celotno poročilo.",
    "fullTitle": "Celotno poročilo za ta naslov",
    "fullNote": "Ocena vrednosti z razponom, primerljive prodaje ter tveganja in naslednji koraki. Obseg je odvisen od razpoložljivih podatkov.",
    "fullCta": "Celotno poročilo · {{price}}",
    "packagesNote": "1 kredit za to nepremičnino · paketi za več naslovov spodaj"
  },
  addressSearch: {
    incompleteAddress: "Vnesite ime ulice ali kraja in hišno številko.",
    addressLabel: "Naslov nepremičnine",
    propertyTypeLabel: "Tip nepremičnine",
    house: "Hiša",
    apartment: "Stanovanje",
    placeholder: "Vnesite naslov (npr. Trubarjeva 10, Ljubljana)",
    ordering: "Naročam...",
    getReport: "Pridobi brezplačno poročilo",
    hintHouse: "Vnesite naslov željene hiše za oceno vrednosti",
    hintApartment: "Vnesite naslov željenega stanovanja za oceno vrednosti",
    hintApartmentNo: " • Dodajte številko stanovanja",
    toastEnterAddress: "Vnesite naslov",
    toastEnterAddressDesc: "Prosimo, vnesite naslov nepremičnine.",
    toastEnterApt: "Vnesite številko stanovanja",
    toastEnterAptDesc: "Prosimo, vnesite številko stanovanja.",
    suggestionsStatus: "{{count}} predlogov naslovov. Izbirajte s puščicama in potrdite z Enter.",
    suggestionsLabel: "Predlogi naslovov",
  },
  askingVsRealized: {
    eyebrow: "Oglaševana proti realizirani ceni",
    title: "Oglaševana cena je šele izhodišče.",
    askingLabel: "Kaj piše v oglasu",
    askingValue: "250.000 €",
    askingNote: "Pričakovanje prodajalca",
    realizedLabel: "Za koliko se je prodalo sosednje stanovanje",
    realizedValue: "218.000 €",
    realizedNote: "Znesek, ki ga je nekdo dejansko plačal (ETN)",
    question: "Oglaševana cena je pričakovanje. Realizirana cena je zabeleženo plačilo.",
    answer:
      "Za presojo cene potrebujete primerljive dejanske prodaje, njihovo starost in razlike med nepremičninami. Poročilo jih zbere in pojasni, kaj podpirajo ter kje so podatki omejeni.",
    caveat:
      "Razlika med oglaševano in realizirano ceno ni v celoti pogajalski prostor — del izhaja iz razlik med primerjanimi nepremičninami in širšega geografskega zajema oglasov. Več v vodniku.",
    cta: "Preberite, kolikšna je razlika in kaj pomeni",
  },
  features: {
    eyebrow: "Funkcionalnosti",
    title: "Kaj vam lahko ponudimo?",
    description:
      "Vse, kar potrebujete za varnejšo odločitev pri nakupu nepremičnine — na enem mestu.",
    items: [
      {
        title: "Uradni GURS podatki",
        description:
          "Enaki podatki, ki jih ima prodajalec — zdaj na vaši strani.",
      },
      {
        title: "Osnovna tržna analiza",
        description:
          "Vidite, za koliko so se zares prodajale nepremičnine v vaši ulici.",
      },
      {
        title: "Lokacijske informacije",
        description:
          "Ugotovite, kaj vpliva na vrednost — preden to ugotovi kupec za vami.",
      },
      {
        title: "AI-podprta ocena",
        description:
          "Računalnik poveže 78+ podatkov, ki bi jih sami pregledovali tedne.",
      },
      {
        title: "Pogajalski PDF list",
        description:
          "Pregleden PDF z utemeljenimi argumenti za nižjo ceno in konkretnimi koraki, ki jih ne smete preskočiti pred podpisom.",
      },
      {
        title: "Enostavno poročilo",
        description:
          "Jasno in pregledno poročilo v PDF obliki, primerno za shranjevanje, deljenje ali posvet s strokovnjakom.",
      },
    ],
  },
  howItWorks: {
    eyebrow: "Postopek",
    title: "Kako deluje?",
    description:
      "Vnesite naslov, preglejte razpoložljive podatke in se odločite, katere korake boste naredili naprej.",
    steps: [
      {
        title: "Vnesite podatke",
        description: "Vnesite naslov nepremičnine za analizo.",
      },
      {
        title: "AI analizira več virov hkrati",
        description:
          "Tržne cene, lokacijo, primerljive prodaje, tveganja in trende.",
      },
      {
        title: "Prejmite poročilo",
        description:
          "Vrednost, opozorila in priporočila – razumljivo tudi brez strokovnega znanja.",
      },
      {
        title: "Pogajajte se z dejstvi",
        description:
          "Konkretni argumenti za nižjo ceno — podprti z uradnimi podatki.",
      },
    ],
  },
  testimonials: {
    eyebrow: "Zaupajo nam mnogi",
    title: "Kaj menijo naši uporabniki",
    description:
      "Prave izkušnje agentov, investitorjev in lastnikov nepremičnin po vsej Sloveniji.",
    items: [
      {
        name: "Marko",
        location: "Ljubljana",
        content:
          "Z nReport-om sem zelo zadovoljen. Njihova AI analiza je pokazala natančnost glede na dejanske prodajne cene. Super storitev!",
      },
      {
        name: "Ana",
        location: "Ljubljana",
        content:
          "Kot licencirana agentka sem začela uporavljat nReport za vse svoje stranke. Njihovi poročila so postala nepogrešljivi - podrobni, zanesljivi in profesionalno pripravljeni. Moji kupci so vedno navdušeni.",
      },
      {
        name: "Matej",
        location: "Maribor",
        content:
          "Ko smo ocenjevali poslovne prostore za širitev, je nReport prihranil mesece dela. Dobili smo tri različne ocene v enem tednu, vse podprte z uradnimi podatki GURS. Investicija se je izplačala že prvi dan.",
      },
      {
        name: "Petra",
        location: "Celje",
        content:
          "Pri delitvi premoženja potrebujem zanesljive ocene. nReport ponuja natanko tisto - profesionalna poročila podprta z uradnimi podatki.",
      },
      {
        name: "Gregor",
        location: "Koper",
        content:
          "Strankam priporočam nReport za hitro informativno oceno. V 24 urah dobijo profesionalno poročilo, ki jim pomaga razumeti vrednost nepremičnine. Odlična storitev!",
      },
    ],
    prevAria: "Prejšnje mnenje",
    nextAria: "Naslednje mnenje",
    goToAria: "Pojdi na mnenje",
  },
  pricing: {
    badge: "Izberite paket",
    title: "Paketi poročil",
    subtitle: "Izberite obseg, ki ustreza vašemu iskanju. Vsi plačljivi paketi vključujejo celotno poročilo.",
    subtitleHighlight:
      "1 kredit = 1 poročilo. Krediti veljajo 1 leto od nakupa.",
    popular: "Za primerjavo možnosti",
    freePlan: {
      badge: "Brezplačno",
      name: "Brezplačen predogled poročila",
      subtitle: "1 povzetek",
      priceLabel: "0 €",
      specialNote: "Po potrditvi e-pošte",
      features: [
        "Uradni podatki GURS in posplošena vrednost",
        "Število realiziranih prodaj in oglasov v okolici",
        "Odprta tveganja, ki jih preverite pred podpisom",
      ],
      lockedNote:
        "Našo oceno vrednosti in preostanek poročila (analiza trga, lokacija, ZK, ETN posli) odklenete z nakupom 1 kredita",
      buttonText: "Preizkusite brezplačno",
      buttonTextLoggedIn: "Na nadzorno ploščo",
    },
    addressWarning:
      'Naslov "{{address}}" ne vsebuje hišne številke. Prosimo, vrnite se nazaj in vnesite popoln naslov z hišno številko za nakup kreditov.',
    anchorAppraisalLabel: "Cenitev sodnega cenilca",
    anchorAppraisalValue: "400 – 600 €",
    anchorOursLabel: "Informativno poročilo nReport",
    anchorOursValue: "od 23,40 €",
    anchorNote:
      "Poročilo ne nadomešča uradne cenitve — je hitrejša in cenejša podlaga za odločitev, ali je cena realna in ali se cenitev sploh splača naročiti.",
    perReport: "/ poročilo",
    includesGurs: "Izpis GURS in preverjanje zemljiškoknjižnega stanja vključena pri vseh paketih",
    notOfficialAppraisal: "Informativno poročilo za pametnejše odločanje — ne nadomešča uradne cenitve",
    selectAddressFirst: "Izberite naslov pred nakupom",
    aptPrefix: "št.",
    securePayment: "100% varno plačilo",
    securePaymentDesc: "preko Stripe • Brez skritih stroškov",
    allCards: "💳 Vse kartice",
    instantActivation: "⚡ Takojšnja aktivacija",
    toastAddressRequired: "Naslov je obvezen",
    toastAddressRequiredDesc:
      "Prosimo, izberite naslov nepremičnine pred nakupom kreditov.",
    toastInvalidAddress: "Neveljaven naslov",
    toastInvalidAddressDesc:
      "Naslov mora vsebovati hišno številko. Prosimo, vnesite popoln naslov.",
    toastAptRequired: "Številka stanovanja je obvezna",
    toastAptRequiredDesc:
      "Prosimo, vnesite številko stanovanja pred nakupom kreditov.",
    plans: [
      {
        name: "Paket 1",
        subtitle: "Dobite 1 poročilo",
        features: [
          "Uradni GURS podatki",
          "Tržna primerjava cen (realizirani posli + oglasi)",
          "Preverjanje zemljiškoknjižnega stanja",
          "AI ocena vrednosti",
          "PDF pogajalski list z argumenti za nižjo ceno",
        ],
        buttonText: "Kupi 1 kredit",
      },
      {
        name: "Paket 2",
        subtitle: "2 poročili",
        specialNote: "Idealno za odločanje med več nepremičninami",
        features: [
          "PDF pogajalski list z argumenti za nižjo ceno",
          "Vse funkcionalnosti paketa 1",
          "Prihranite 20% na poročilo",
        ],
        buttonText: "Kupi 2 kredita",
      },
      {
        name: "Paket 3",
        subtitle: "5 poročil",
        specialNote: "Najnižja cena na poročilo",
        features: [
          "PDF pogajalski list z argumenti za nižjo ceno",
          "Vse funkcionalnosti paketa 1",
          "Prihranite 40% na poročilo",
        ],
        buttonText: "Kupi 5 kreditov",
      },
    ],
    buy: "Nakup",
  },
  faq: {
    eyebrow: "Pomoč",
    title: "Pogosto zastavljena vprašanja",
    description:
      "Odgovori na najpogostejša vprašanja o naših poročilih o nepremičninah.",
    contactTitle: "Imate vprašanje?",
    contactDesc: "Pišite nam in z veseljem vam bomo odgovorili.",
    contactCta: "Pošljite vprašanje",
    items: FAQ_SL,
  },
  ratingStats: {
    eyebrow: "Zadovoljstvo",
    title: "Zadovoljstvo naših uporabnikov",
    description:
      "Ocene in priporočila v realnem času od uporabnikov, ki so že prejeli poročilo.",
    recommend: "uporabnikov nas priporoča",
    averageRating: "povprečna ocena",
    votes: "glasov",
  },
  footer: {
    tagline:
      "Neodvisna poročila o nepremičninah v Sloveniji. Podatki, podlage in naslednji koraki v razumljivi obliki.",
    legalHeading: "Pravne informacije",
    terms: "Splošni pogoji",
    privacy: "Varstvo podatkov",
    cookies: "Piškotki",
    dataDeletion: "Brisanje podatkov",
    cookieSettings: "Nastavitve piškotkov",
    trustedSources: "Zaupanja vredni viri",
    trustedSourcesDesc:
      "Javne evidence in tržni podatki v enem poročilu. Razpoložljivost posameznih podatkov in izpiskov je odvisna od nepremičnine.",
    copyright: "© 2026 Noventis d.o.o. Vse pravice pridržane.",
    slogan: "nReport.ai — pametnejši nakup nepremičnine",
    backToTop: "Nazaj na vrh",
  },
  newsletter: {
    heading: "Novice nReport",
    description:
      "Analize nepremičninskega trga, novi vodniki in posodobitve. Enkrat na mesec, brez neželene pošte.",
    placeholder: "vas@email.si",
    submit: "Prijavi me",
    success: "Hvala! Prijavljeni ste na novice.",
    error: "Prijava ni uspela. Poskusite znova.",
    invalidEmail: "Vnesite veljaven e-naslov.",
    privacy: "Odjavite se lahko kadar koli.",
    optIn: "Želim prejemati novice o nepremičninskem trgu (odjava kadar koli).",
  },
  sampleExplorer: {
    loadError: "Ogleda vzorca ni bilo mogoče odpreti. Celoten vzorec lahko še vedno prenesete.",
    loading: "Odpiramo vzorec…",
    "title": "Raziščite vzorčno poročilo",
    "description": "Hiter pregled ocene, dokazov in odprtih vprašanj. Prikaz je izmišljen; celoten vzorec PDF je v slovenščini.",
    "close": "Zapri vzorec",
    "sections": "Vsebina vzorca",
    "value": "Vrednost",
    "evidence": "Podatki",
    "checks": "Preverjanja",
    "valueTitle": "Cena potrebuje kontekst.",
    "valueNote": "Ocena je orientacija za presojo oglaševane cene. Razpon pokaže negotovost; posamezna številka ne more nadomestiti ogleda ali strokovne cenitve.",
    "salesNote": "Zabeležene prodaje pokažejo dejansko plačane cene, datume in primerljive nepremičnine.",
    "registryNote": "Površina, leto gradnje in identifikatorji pomagajo preveriti, katero nepremičnino primerjate.",
    "listingsNote": "Aktualni oglasi pokažejo pričakovanja prodajalcev. Oglaševane cene niso realizirane prodajne cene.",
    "askingPrices": "Oglaševane cene",
    "availability": "Razpoložljivost virov in primerljivih podatkov je odvisna od nepremičnine.",
    "checkTitle": "Vedite, kaj je treba še preveriti.",
    "checkNote": "Jasno označena odprta vprašanja pomagajo pripraviti naslednje korake pred podpisom. Razpoložljiv zemljiškoknjižni izpis je podlaga za preverjanje lastništva in bremen.",
    "openPdf": "Odpri celoten PDF",
    "back": "Nazaj na pregled",
    "price": "1 celotno poročilo · {{price}}",
    "cta": "Izberite poročilo"
  },
  pdfPreview: {
    title: "Primer poročila nReport",
    download: "Prenesi PDF",
    downloadShort: "Prenesi",
    orderReport: "Naroči poročilo",
    iframeTitle: "Vzorec PDF poročila",
  },
  contact: {
    eyebrow: "Kontakt",
    title: "Pošljite nam vprašanje",
    description:
      "Izpolnite obrazec in odgovorili vam bomo v najkrajšem možnem času.",
    nameLabel: "Ime in priimek",
    namePlaceholder: "Janez Novak",
    emailLabel: "E-poštni naslov",
    emailPlaceholder: "janez@primer.si",
    messageLabel: "Vaše vprašanje",
    messagePlaceholder: "Opišite svoje vprašanje...",
    successTitle: "Sporočilo poslano",
    successDesc:
      "Hvala za vaše vprašanje. Odgovorili vam bomo v najkrajšem možnem času.",
    errorSend: "Sporočila ni bilo mogoče poslati. Prosimo, poskusite ponovno.",
    validation: {
      nameRequired: "Ime je obvezno",
      nameTooLong: "Ime je predolgo",
      emailInvalid: "Neveljaven e-poštni naslov",
      emailTooLong: "E-pošta je predolga",
      messageRequired: "Sporočilo je obvezno",
      messageTooLong: "Sporočilo je predolgo",
    },
  },
  auth: {
    signedOutTitle: "Odjavljeni",
    signedOutDesc: "Uspešno ste se odjavili.",
    signOutError: "Napaka pri odjavi. Poskusite znova.",
    login: "Prijava",
    register: "Registracija",
    loginDesc: "Prijavite se za dostop do svojih kreditov in poročil.",
    registerDesc:
      "Ustvarite račun za nakup kreditov in dostop do poročil. Po potrditvi e-pošte prejmete brezplačen kredit za predogled poročila.",
    displayName: "Prikazno ime",
    displayNamePlaceholder: "npr. Janez Novak",
    email: "E-pošta",
    password: "Geslo",
    showPassword: "Pokaži geslo",
    hidePassword: "Skrij geslo",
    legalNotice: "Z registracijo sprejemate",
    legalTerms: "Splošne pogoje",
    legalPrivacy: "Politiko zasebnosti",
    passwordHint:
      "Geslo mora biti dolgo vsaj 8 znakov in vsebovati velike in male črke ter številke.",
    loginSubmit: "Prijavite se",
    registerSubmit: "Registrirajte se",
    loginWithGoogle: "Prijavite se z Google",
    registerWithGoogle: "Registrirajte se z Google",
    loginWithFacebook: "Prijavite se z Facebook",
    registerWithFacebook: "Registrirajte se z Facebook",
    noAccount: "Nimate računa? Registrirajte se",
    hasAccount: "Že imate račun? Prijavite se",
    invalidEmail: "Vnesite veljaven e-poštni naslov",
    forgotPassword: "Ste pozabili geslo?",
    resetEnterEmail: "Najprej vnesite svoj e-poštni naslov.",
    resetSentTitle: "Povezava za ponastavitev poslana",
    resetSentDesc: "Preverite svoj e-poštni predal za povezavo za ponastavitev gesla.",
    resetError: "Povezave za ponastavitev ni bilo mogoče poslati. Poskusite znova.",
    recoveryTitle: "Nastavite novo geslo",
    recoveryDesc: "Izberite novo geslo za svoj račun.",
    recoverySubmit: "Posodobi geslo",
    passwordUpdatedTitle: "Geslo posodobljeno",
    passwordUpdatedDesc: "Zdaj se lahko prijavite z novim geslom.",
    displayNameTooShort: "Prikazno ime mora imeti vsaj 2 znaka",
    passwordTooShort: "Geslo mora biti dolgo vsaj 8 znakov",
    passwordNeedsLower: "Geslo mora vsebovati vsaj eno malo črko",
    passwordNeedsUpper: "Geslo mora vsebovati vsaj eno veliko črko",
    passwordNeedsDigit: "Geslo mora vsebovati vsaj eno številko",
    invalidCredentials: "Napačni prijavni podatki",
    resendConfirmationTitle: "Potrditveni e-mail poslan",
    resendConfirmationSent: "Preverite svoj e-poštni predal za novo povezavo za potrditev.",
    resendConfirmationFailed: "Potrditvenega e-maila ni bilo mogoče ponovno poslati. Poskusite znova čez nekaj minut.",
    userExists: "Uporabnik s tem e-poštnim naslovom že obstaja",
    weakPassword:
      "To geslo je preveč pogosto in lahko uganljivo. Prosimo, izberite močnejše geslo.",
    registerSuccess: "Uspešna registracija",
    registerSuccessDesc:
      "Preverite svoj e-poštni predal za potrditev. Po potrditvi prejmete brezplačen kredit za predogled poročila.",
    suspiciousActivity:
      "Zaznana je bila suma neobičajne aktivnosti. Počakajte nekaj minut.",
    googleError: "Napaka pri prijavi z Google. Poskusite znova.",
    facebookError: "Napaka pri prijavi z Facebook. Poskusite znova.",
    redirectingToGoogle: "Preusmerjanje na Google...",
    completingSignIn: "Dokončujem prijavo...",
  },
  dashboard: {
    title: "Nadzorna plošča",
    loginPrompt: "Prijavite se za dostop do nadzorne plošče.",
    loadingSession: "Dokončujem prijavo...",
    welcome: "Dobrodošli, {{name}}!",
    subtitle: "Vaša poročila, krediti in naročila — vse na enem mestu.",
    orderTitle: "Naroči poročilo o nepremičnini",
    orderDesc: "Vnesite naslov nepremičnine za pripravo poročila.",
    orderCta: "Naroči poročilo (1 kredit)",
    orderPaidCta: "Naroči podrobno poročilo (1 kredit)",
    orderPreviewCta: "Pridobi brezplačni predogled",
    orderPaidDesc: "Vnesite naslov nepremičnine. Za podrobno poročilo se porabi 1 kupljen kredit.",
    orderPreviewDesc: "Na voljo imate brezplačni kredit za predogled poročila. Za odklep podrobnega poročila potrebujete kupljen kredit.",
    insufficientCredits: "Ni dovolj kreditov",
    insufficientCreditsDesc:
      "Nimate dovolj veljavnih kreditov za naročilo poročila. Potreben je 1 kredit.",
    insufficientCreditsShort:
      "Nimate dovolj veljavnih kreditov za naročilo poročila.",
    orderError: "Napaka pri naročilu poročila",
    propertyNotFound: "Naslov ni v katastru",
    propertyNotFoundDesc:
      "Naslov ni bil najden v evidenci GURS. Preverite hišno številko in ali je naslov pravilen.",
    apartmentNotFound: "Stanovanje ni najdeno",
    apartmentNotFoundDesc:
      "Stanovanje s to številko na navedenem naslovu ni bilo najdeno v katastru.",
    orderSuccess: "Poročilo naročeno",
    orderSuccessDesc: "Vaše poročilo je v pripravi.",
    orderHeldDesc: "Poročilo dopolnimo z izpiskom iz zemljiške knjige in vam ga dostavimo na e-naslov v 1 delovnem dnevu.",
    genericError: "Prišlo je do napake. Poskusite znova.",
    statCredits: "Razpoložljivi krediti",
    statInProgress: "V pripravi",
    statCompleted: "Dokončana poročila",
    statInProgressInline: "{{count}} v pripravi",
    statCompletedInline: "{{count}} dokončanih",
    lowCreditsTitle: "Zmanjkalo vam je kreditov",
    lowCreditsDesc:
      "Kupite kredite spodaj, da naročite naslednje poročilo o nepremičnini.",
    creditHistoryToggle: "Zgodovina kreditov",
    newReportEyebrow: "Novo poročilo",
    reportsEyebrow: "Vaša poročila",
    loadError: {
      retry: "Poskusi znova",
      unavailable: "Ni naloženo",
      hint: "Vaši podatki niso izgubljeni. Preverite povezavo in poskusite znova.",
      credits: "Stanja kreditov ni bilo mogoče naložiti.",
      orders: "Vaših poročil ni bilo mogoče naložiti.",
      transactions: "Zgodovine kreditov ni bilo mogoče naložiti.",
    },
    expiringCredits: {
      title: "{count} kreditov kmalu poteče",
      desc: "Vaših {count} neporabljenih kreditov poteče {date}. Po tem datumu jih ni več mogoče uporabiti, zato jih izkoristite pravočasno.",
    },
    bulk: {
      addAddress: "Dodaj na seznam",
      eyebrow: "Več nepremičnin",
      title: "Naroči več poročil hkrati",
      desc: "Dodajte nepremičnine na seznam in jih naročite v enem koraku. Za vsako poročilo se porabi en kredit.",
      apartment: "Stanovanje št.",
      duplicate: "Ta nepremičnina je že na seznamu.",
      remove: "Odstrani s seznama",
      placed: "Naročeno",
      failed: "Ni uspelo",
      skippedNoCredits: "Ni naročeno — zmanjkalo je kreditov.",
      needCredits: "{count} nepremičnin na seznamu · na voljo imate {balance} kreditov",
      partialWarning: "Naročenih bo prvih {n}.",
      submit: "Naroči {count} poročil",
      running: "Naročam {done}/{total} …",
      doneTitle: "Naročanje končano",
      doneDesc: "Naročenih {placed} od {total} poročil.",
    },
  },
  checkout: {
    tagline: "Poročila o nepremičninah",
    back: "Nazaj",
    orderSummary: "Povzetek naročila",
    unlockTitle: "Odklep poročila",
    unlockDesc: "Kredit bo takoj po plačilu porabljen za odklep tega poročila.",
    package: "Paket",
    credits: "Krediti",
    address: "Naslov",
    total: "Skupaj",
    includesVat: "Vključuje DDV",
    vatExempt: "Končna cena. DDV ni obračunan na podlagi 1. odstavka 94. člena ZDDV-1.",
    securePaymentTitle: "Varno plačilo",
    securePaymentDesc:
      "Vaše plačilne podatke obravnava Stripe. Vaši podatki so varni in šifrirani.",
    creditsValidity: "1 kredit = 1 poročilo. Krediti veljajo 1 leto od nakupa.",
    paymentTitle: "Plačilo",
    paymentDesc: "Dokončajte svoj nakup z varnim plačilom preko Stripe",
    loadingPayment: "Nalaganje plačilnega sistema...",
    legalTitle: "Pravno obvestilo",
    legalDesc:
      "Poročilo je namenjeno izključno informativnim namenom in ne predstavlja uradne cenitve nepremičnine. Podatki in analize so pripravljeni na podlagi javno dostopnih evidenc in statističnih modelov, ki ne nadomeščajo strokovne cenitve pooblaščenega cenilca.",
    missingData: "Manjkajo potrebni podatki za nakup. Prosimo, poskusite znova.",
    paymentEyebrow: "Plačilo",
    paymentSuccess: "Plačilo uspešno!",
    redirecting: "Preusmerjanje...",
    creditOne: "kredit",
    creditTwo: "kredita",
    creditFew: "krediti",
    creditMany: "kreditov",
  },
  paymentSuccess: {
    processingEyebrow: "Plačilo",
    processingTitle: "Potrjujemo vaše plačilo …",
    processingDesc: "To traja le nekaj sekund. Prosimo, ne zapirajte strani.",
    loginTitle: "Prijavite se za ogled statusa plačila",
    loginDesc: "Vaše plačilo je varno. Prijavite se z računom, s katerim ste plačali, in krediti bodo potrjeni kar tukaj.",
    successEyebrow: "Plačilo potrjeno",
    successTitle: "Hvala, plačilo je prejeto",
    successDesc: "Krediti so na vašem računu in pripravljeni za uporabo.",
    paymentFailed: "Plačilo ni bilo uspešno",
    processingError: "Prišlo je do napake pri obdelavi vašega naročila.",
    stepsLabel: "Potek naročila",
    stepPayment: "Plačilo prejeto",
    stepPaymentActive: "Preverjamo plačilo …",
    stepCredits: "Krediti dodani",
    stepCreditsActive: "Dodajamo kredite na vaš račun …",
    stepCreditsDone: "Dodano na vaš račun: {{credits}}",
    stepCreditsWaiting: "Traja dlje kot običajno – krediti bodo dodani samodejno.",
    stepOrder: "Poročilo v pripravi",
    stepOrderActive: "Začenjamo pripravo poročila za vneseni naslov …",
    stepOrderDone: "Začeli smo pripravo poročila za vneseni naslov. Kmalu bo na voljo na vaši nadzorni plošči.",
    stepOrderFailed: "Poročila nismo mogli zagnati samodejno. Kredit vam ostane – poročilo naročite na nadzorni plošči.",
    stepUnlock: "Celotno poročilo",
    stepUnlockActive: "Odklepamo vaše poročilo …",
    stepUnlockDone: "Celotno poročilo je pripravljeno za ogled.",
    stepUnlockHeld: "Plačano. Celotno poročilo z izpiskom iz zemljiške knjige vam dostavimo v 1 delovnem dnevu.",
    stepUnlockFailed: "Kredit vam ostane – poročilo odklenete z enim klikom na strani poročila.",
    stepNext: "Naročite poročilo",
    stepNextDesc: "Na nadzorni plošči vnesite naslov nepremičnine. Vsako poročilo porabi 1 kredit.",
    statusDone: "opravljeno",
    statusActive: "v teku",
    statusPending: "na čakanju",
    statusNext: "naslednji korak",
    statusAttention: "zahteva pozornost",
    delayedTitle: "Plačilo je prejeto, krediti so na poti",
    delayedDesc: "Plačilo je potrjeno, vendar dodajanje kreditov traja dlje kot običajno – navadno se uredi v minuti. Preverite znova ali odprite nadzorno ploščo, kjer se bodo krediti prikazali.",
    checkAgain: "Preveri znova",
    checkingAgain: "Preverjam …",
    errorTitle: "Plačila še nismo mogli potrditi",
    errorDesc: "Če je bil znesek bremenjen, so vaši krediti varni. Poskusite znova čez trenutek ali nam pišite.",
    missingSessionTitle: "Tega plačila ne najdemo",
    missingSessionDesc: "Povezavi manjka oznaka plačila. Če je bil znesek bremenjen, se bodo krediti prikazali na vaši nadzorni plošči.",
    redirectDashboardIn: "Na nadzorno ploščo vas preusmerimo čez {{seconds}} s.",
    redirectReportIn: "Poročilo se odpre čez {{seconds}} s.",
    stayHere: "Ostani na tej strani",
    goToDashboard: "Pojdi na nadzorno ploščo",
    openReport: "Odpri poročilo",
    backHome: "Nazaj na domačo stran",
    contactLead: "Imate vprašanje? Pišite nam na",
    announceConfirming: "Preverjamo vaše plačilo.",
    announceCompleted: "Plačilo je potrjeno. Dodano na vaš račun: {{credits}}.",
    guestTitle: "Plačilo prejeto!",
    guestDesc: "Na vaš e-naslov smo poslali povezavo za prijavo, kjer dostopate do svojih kreditov za poročila.",
    guestSpam: "Če e-pošte v nekaj minutah ne vidite, preverite mapo z neželeno pošto.",
  },
  postPurchaseSurvey: {
    question: "Kratko vprašanje — kaj vas je skoraj odvrnilo od nakupa?",
    options: {
      price: "Cena",
      trust: "Nezaupanje v točnost podatkov",
      unclear: "Nejasno, kaj je vključeno",
      technical: "Težave s plačilom/tehnične težave",
      nothing: "Nič — bilo je preprosto",
    },
    skip: "Preskoči",
    thanks: "Hvala za vaše mnenje!",
  },
  paymentTrust: {
    acceptedMethods: "Sprejemamo vse glavne kartice",
    securedByStripe: "Varno plačilo prek Stripe",
    encryptedNote: "Podatki o kartici so šifrirani in nikoli ne dosežejo naših strežnikov.",
  },
  checkoutSupport: {
    contact: "Kontaktirajte podporo",
    cancellation: "14-dnevna pravica do odstopa",
  },
  checkoutSteps: {
    package: "Paket",
    payment: "Plačilo",
    done: "Potrditev",
  },
  checkoutUpsell: {
    title: "Potrebujete več kot eno?",
    desc: "Pridobite {{credits}} poročil za €{{price}} — le €{{per}} na poročilo, {{discount}}% ceneje.",
    cta: "Izberi ta paket",
  },
  paymentCanceled: {
    eyebrow: "Preklicano",
    title: "Plačilo preklicano",
    desc: "Vaše plačilo je bilo preklicano. Nobena sredstva niso bila zaračunana z vašega računa.",
    help: "Če se je zgodila napaka ali imate težave s plačilom, nas kontaktirajte za pomoč.",
    backHome: "Nazaj na domačo stran",
    tryAgain: "Poskusi znova",
    contact: "Za pomoč pri plačilu nas kontaktirajte na info@nreport.ai",
  },
  notFound: {
    eyebrow: "Napaka 404",
    title: "Stran ni bila najdena",
    desc: "Oprostite, stran, ki jo iščete, ne obstaja ali je bila premaknjena.",
    backHome: "Nazaj na domačo stran",
    goBack: "Pojdi nazaj",
  },
  errorBoundary: {
    eyebrow: "Napaka",
    title: "Nekaj je šlo narobe",
    desc: "Prišlo je do nepričakovane napake. Poskusite osvežiti stran ali se obrnite na podporo.",
    retry: "Poskusi ponovno",
    reload: "Osveži stran",
    devDetails: "Razvojne informacije",
  },
  quickPurchase: {
    title: "Hitri nakup kreditov",
    popular: "Priljubljen",
    packages: [
      { name: "Kupi 1 kredit", description: "Enkratno poročilo" },
      { name: "Kupi 2 kredita", description: "Prihranek 20%" },
      { name: "Kupi 5 kreditov", description: "Prihranek 40%" },
    ],
  },
  orderStatus: {
    title: "Moja poročila",
    desc: "Prenesite dokončana poročila ali spremljajte tista v pripravi",
    noOrders: "Še nimate poročil",
    noOrdersHint: "Naročite svoje prvo poročilo o nepremičnini spodaj.",
    defaultTitle: "Poročilo o nepremičnini",
    apartment: "Stanovanje",
    house: "Hiša",
    property: "Nepremičnina",
    aptNo: "Št.",
    downloadPdf: "Prenesi PDF",
    openPdf: "Odpri poročilo v novem zavihku",
    refresh: "Osveži naročila",
    loadMore: "Pokaži starejša poročila",
    loadingMore: "Nalagam starejša poročila …",
    loadedCount: "Prikazanih poročil: {{count}}",
    loadMoreError: "Starejših poročil ni bilo mogoče naložiti. Poskusite znova.",
    dateUnknown: "Datum neznan",
    thumbnailAlt: "Predogled zemljevida za {{address}}",
    readyBadge: "Pripravljeno",
    previewBadge: "Predogled",
    unlockHeldBadge: "Plačano – v pripravi",
    hintCompleted: "Vaše poročilo je pripravljeno za prenos.",
    hintProcessing: "Analiziramo nepremičnino — običajno traja nekaj minut.",
    hintPending: "Poročilo je v čakalni vrsti in se bo kmalu začelo pripravljati.",
    hintFailed: "Nekaj je šlo narobe. Če se težava ponavlja, kontaktirajte podporo.",
    hintRefunded: "Priprave poročila ni bilo mogoče začeti, zato smo vam kredit vrnili. Poročilo lahko naročite znova.",
    hintNeedsReview: "Samodejna kontrola kakovosti je v poročilu našla neskladje, zato ga pred pošiljanjem pregledamo ročno. Obvestili vas bomo, ko bo pripravljeno.",
    hintAwaitingApproval: "Poročilo je pripravljeno, pred pošiljanjem pa ga še osebno pregledamo. Ko ga odobrimo, ga prejmete po e-pošti.",
    statusUnknown: "Neznano",
    statusCompleted: "Dokončano",
    statusProcessing: "V obdelavi",
    statusPending: "V čakanju",
    statusFailed: "Neuspešno",
    statusCancelled: "Preklicano",
    statusNeedsReview: "V pregledu",
    viewReport: "Odpri poročilo",
    generation: {
      live: "V živo",
      phaseQueued: "V vrsti",
      phaseChecking: "Preverjamo nepremičnino",
      phaseWriting: "Pišemo analizo",
      phaseMarket: "Tržna analiza in kontrola",
      phasePdf: "Izdelujemo PDF",
      phaseDone: "Pripravljeno",
      etaMinutes: "še približno {{count}} min",
      etaUnderMinute: "še manj kot minuto",
      etaLonger: "Traja dlje kot običajno — poročilo bo kljub temu pripravljeno.",
      typicalDuration: "Običajno traja približno 3 minute.",
      heldTitle: "Pridobivamo izpisek iz zemljiške knjige",
      heldDesc: "Plačano poročilo dopolnimo z zemljiškoknjižnim izpiskom. Pripravljeno poročilo vam dostavimo na e-naslov v 1 delovnem dnevu.",
      activeTitle: "Poročila v pripravi",
      activeDesc: "Spremljajte napredek v živo. Ko bo poročilo pripravljeno, se bo tu pojavila povezava do njega.",
      viewAll: "Vsa poročila",
      duplicateTitle: "Za ta naslov že imate poročilo",
      duplicateDesc: "Naročilo za {{address}} že obstaja ({{status}}). Novo naročilo porabi dodaten kredit in ustvari drugo poročilo za isto nepremičnino.",
      duplicateConfirm: "Naroči vseeno (1 kredit)",
      duplicateCancel: "Prekliči",
    },
  },
  reportDetail: {
    navigationTitle: "Raziščite poročilo",
    loading: "Nalagam poročilo...",
    notFound: "Poročilo ni bilo najdeno.",
    dataUnavailable: "Podatki poročila še niso na voljo.",
    backToDashboard: "Nazaj na nadzorno ploščo",
    paywall: {
      eyebrow: "Brezplačni predogled",
      title: "Le en korak do celotnega poročila",
      description: "Podatke za nepremičnino na naslovu {{address}} smo že zbrali in analizirali. Spodaj je, kaj odklenete.",
      findingsTitle: "Kaj smo našli za to nepremičnino",
      estimateLabel: "Ocenjena tržna vrednost",
      estimateNote: "z razponom in stopnjo zanesljivosti",
      ceilingLabel: "Zaokrožena orientacijska vrednost",
      ceilingNote: "zaokroženo izhodišče analize, ki ga preverite glede na svoje okoliščine",
      salesLabel: "Realizirane prodaje v okolici",
      salesYears: "{{from}}–{{to}}",
      salesClosest: "najbližja {{distance}} m stran",
      listingsLabel: "Primerljivi oglasi",
      listingsNote: "povprečna oglaševana cena na m²",
      gapLabel: "Oglaševane vs. dosežene cene",
      gapNote: "razlika med ceno v oglasu in prodajno ceno v okolici",
      argumentsLabel: "Pogajalski argumenti",
      argumentsNote: "z natisljivim listom za na ogled",
      riskLabel: "Pred podpisom preverite",
      riskNote: "Kaj točno storiti, piše v celotnem poročilu.",
      includesTitle: "Celotno poročilo vsebuje",
      includes: {
        estimate: "Informativno oceno vrednosti z razponom in stopnjo zanesljivosti",
        method: "Izračun ocene korak za korak iz uradnih podatkov",
        sales: "Realizirane prodaje (ETN) na zemljevidu s cenami in datumi",
        trend: "Graf gibanja cen v okolici po letih",
        listings: "Primerljive oglase s cenami in povezavami",
        location: "Analizo lokacije in storitev v bližini",
        cadaster: "Ključne značilnosti stavbe in katastrske podatke",
        risks: "Seznam tveganj in korake pred podpisom pogodbe",
        negotiation: "Pogajalska izhodišča in natisljiv list za ogled",
        attachments: "Priloge: GURS vrednotenje in katastrski izpis",
        attachmentsEnergy: "Priloge: GURS vrednotenje, katastrski izpis in energetsko izkaznico",
        pdf: "Celoten PDF za prenos in tisk",
      },
      priceNote: "Enkratno plačilo · brez naročnine",
      buyCta: "Odkleni celotno poročilo",
      instant: "Celotno poročilo z izpiskom iz zemljiške knjige vam dostavimo v 1 delovnem dnevu.",
      heldTitle: "Plačano – celotno poročilo pripravljamo",
      secure: "Varno plačilo s kartico prek Stripe",
      sample: "Oglejte si vzorec celotnega poročila (PDF)",
      bundle: "Kupujete več nepremičnin? 5 poročil za {{price}} ({{per}} na poročilo)",
      stickyLabel: "Brezplačni predogled",
      stickyCta: "Odkleni za {{price}}",
      unlockCta: "Odkleni poročilo (1 kredit)",
      unlocking: "Odklepam...",
      creditsAvailable: "Na voljo imate {{count}} kupljenih kreditov",
      unlockedTitle: "Poročilo odklenjeno",
      unlockedDesc: "Celotno poročilo je zdaj na voljo.",
      unlockedPdfPending: "Poročilo je odklenjeno. Celoten PDF se še pripravlja — poskusite prenos čez nekaj trenutkov.",
      unlockFailedTitle: "Odklep ni uspel",
      downloadPreview: "Prenesi predogled",
    },
    attachments: {
      title: "Priloge",
      description:
        "Izvorni dokumenti, priloženi poročilu (vključeni so tudi v prenesenem PDF).",
      valuation: "Vrednotenje nepremičnine (GURS)",
      cadastral: "Katastrski izpis (GURS)",
      energy: "Energetska izkaznica",
      uploaded: "Priložen dokument",
    },
    badge: "nReport.ai poročilo o nepremičnini",
    title: "Analiza nepremičnine",
    sectionOverviewEyebrow: "Pregled nepremičnine",
    sectionOverviewTitle: "Osnovne značilnosti",
    sectionOverviewDesc:
      "Vrsta in raba nepremičnine, lega v stavbi, razpored prostorov, konstrukcija in oprema.",
    sectionFeaturesEyebrow: "Povzetek",
    sectionFeaturesTitle: "Ključni podatki",
    sectionMarketEyebrow: "AI tržna analiza",
    sectionMarketTitle: "Napredna analiza trga",
    sectionMarketDesc:
      "Celovita analiza tržnih razmer s pomočjo umetne inteligence in statističnih modelov.",
    sectionMethodologyEyebrow: "Metodologija",
    sectionMethodologyTitle: "Informativna vrednost",
    sectionMethodologyDesc:
      "Tehtana ocena, ki uskladi uradno GURS vrednost z oglaševanimi in realiziranimi tržnimi cenami.",
    sectionLocationEyebrow: "Lokacija",
    sectionLocationTitle: "Umestitev v prostor",
    sectionLocationDesc: "Analiza lokacije in okolice nepremičnine.",
    sectionCadasterEyebrow: "Zemljiškoknjižno stanje",
    sectionCadasterTitle: "Analiza izpisa iz zemljiške knjige",
    sectionValuationEyebrow: "Vrednotenje nepremičnine",
    sectionValuationTitle: "Uradna vrednost nepremičnine",
    sectionValuationDesc: "GURS posplošena tržna vrednost stavbe in zemljišča.",
    sectionEtnEyebrow: "Zgodovina transakcij",
    sectionEtnTitle: "Realizirani posli v okolici",
    sectionEtnDesc:
      "Pregled dejansko realiziranih prodaj primerljivih nepremičnin iz evidence trga nepremičnin (ETN).",
    sectionAdsEyebrow: "Pregled trga",
    sectionAdsTitle: "Primerljive oglaševane nepremičnine",
    sectionAdsDesc: "Izbor oglaševanih nepremičnin z najbolj primerljivimi metrikami.",
    sectionAdsDescCohort:
      "Reprezentativni izbor {{shown}} od {{total}} oglasov, vključenih v analizo oglaševanih cen. Povprečje, razpon in zanesljivost so izračunani iz vseh {{total}}.",
    adsScopeTitle: "Kako smo izbrali primerljive oglase",
    recommendations: "Priporočila",
    priceAnalysis: "Cenovna analiza",
    marketPosition: "Tržni položaj",
    propertyCharacteristics: "Značilnosti nepremičnin",
    investmentInsights: "Investicijski vpogledi",
    buildingValuation: "Vrednotenje stavbe",
    landValuation: "Vrednotenje zemljišča",
    satelliteMap: "Satelitski pogled",
    streetView: "Street View",
    disclaimerTitle: "Pravno obvestilo",
    disclaimerText:
      "To poročilo je namenjeno izključno informativnim namenom in ne predstavlja uradne cenitve nepremičnine. Podatki in analize so pripravljeni na podlagi javno dostopnih evidenc in statističnih modelov, ki ne nadomeščajo strokovne cenitve pooblaščenega cenilca.",
    area: "Površina",
    netArea: "Neto tlorisna površina",
    usableArea: "Uporabna površina",
    landArea: "Velikost zemljišča",
    yearBuilt: "Leto izgradnje",
    metricInformativeValue: "Informativna vrednost",
    metricGursValue: "Posplošena vrednost GURS",
    metricMarketPriceM2: "Ocena trga (oglasi)",
    metricEtnPriceM2: "Realizirana vrednost (ETN)",
    metricEtnGrowth: "Letna rast cen (CAGR)",
    metricEtnGrowthHint: "Zgodovinska rast realiziranih cen/m² v okolici ({{period}}). Ni donos od najema in ni napoved.",
    metricEtnHistoricalHint:
      "Povprečje starejših poslov — v zadnjem obdobju ni primerljive prodaje, zato v oceno vrednosti ni vključeno.",
    metricEtnGrowthHintNoPeriod:
      "Zgodovinska rast realiziranih cen/m² v okolici. Ni donos od najema in ni napoved.",
    gursGapLabel: "Razlika do GURS",
    distributionTitle: "Informativna ocena ob pogodbenih cenah poslov",
    distributionLead:
      "Prikazane so pogodbene cene na m² in informativna ocena. Pogodbene cene na tej sliki niso časovno ali modelno usklajene z oceno; razlika sama po sebi ne dokazuje popusta ali precenjenosti.",
    distributionAlt: "Porazdelitev realiziranih cen na m²",
    negotiationSheetDownload: "Pogajalski list",
    negotiationEyebrow: "Pogajalski list",
    negotiationTitle: "Argumenti, podprti s podatki",
    negotiationDesc:
      "Vsak argument spodaj izhaja iz podatkov v tem poročilu in navaja svoj vir. Namenjeni so temu, da jih poveste na glas — ne da jih razlagate.",
    negotiationCeilingLabel: "Zaokrožena orientacijska vrednost",
    negotiationBatna:
      "Osebno zgornjo mejo ponudbe določite glede na svoj proračun, stroške nakupa in potrebnih del ter odprta vprašanja. Lahko se razlikuje od orientacijske vrednosti analize.",
    negotiationSourcePrefix: "Vir:",
    negotiationHowToTitle: "Kako uporabiti te argumente",
    negotiationHowTo: [
      "Ne začnite s ceno. Vprašajte: „Kako ste prišli do te cene?“ Pustite, da prodajalec razloži, nato pokažite podatke.",
      "Pokažite, ne zahtevajte: „Pogledal sem realizirane posle v okolici — primerljive nepremičnine so se prodale za X. Kako komentirate razliko?“",
      "Ponudbe ne opravičujte. Podprta je s podatki; dokument je vaš argument, ne vi.",
      "Ko izrečete številko, počakajte. Tišina je pogajalsko orodje.",
      "Če slišite „to je pod trgom“, vprašajte: „Kateri realizirani posli to podpirajo?“",
    ],
    negotiationLimitsTitle: "Omejitve.",
    negotiationLimits:
      "Analiza temelji na javno dostopnih evidencah (GURS, ETN, oglasne platforme) in ne nadomešča uradne cenitve. Realizirani posli so najboljši dostopen približek tržne vrednosti, ne pa absolutna resnica. Izid pogajanj je odvisen tudi od motivacije prodajalca, pogojev financiranja in dejavnikov, ki jih ta analiza ne more predvideti.",
    keyFactsEyebrow: "Osnovni podatki",
    keyFactsTitle: "Nepremičnina na en pogled",
    addressSpreadTitle: "Razpon evidentiranih cen na istem naslovu",
    addressSpreadAnd: "in",
    addressSpreadExplain:
      "Posli na istem naslovu lahko zajemajo različne dele stavbe, datume prodaje in pogoje posla. Sam razpon cen ne potrjuje njihove primerljivosti niti napake v podatkih. Celotnega razloga za razliko iz evidence ni mogoče ugotoviti; upoštevajte navedene podatke in omejitve posameznega posla.",
    selectionNoteTitle: "Kako smo izbrali primerljive posle.",
    selectionNote:
      "V radiju {{radius}} km smo pregledali {{considered}} realiziranih poslov in jih v analizo vključili {{used}}. Upoštevali smo posle s površino med {{min}} in {{max}} m².",
    selectionNoteNoSize:
      "V radiju {{radius}} km smo pregledali {{considered}} realiziranih poslov in jih v analizo vključili {{used}}. Površina te nepremičnine v GURS ni znana, zato poslov nismo omejili po velikosti in primerljivost po velikosti ni zagotovljena.",
    selectionNoteLandRatio: "Pri hišah smo dodatno zahtevali podobno razmerje med zemljiščem in stavbo.",
    selectionNoteOutliers:
      "{{count}} poslov smo izločili kot statistične osamelce — cena na m² je bila toliko izven lokalnega razpona, da gre najverjetneje za netržni prenos.",
    selectionNoteCohort:
      "Za oceno vrednosti smo uporabili {{used}} od {{considered}} pregledanih poslov v radiju {{radius}} km — tiste, sklenjene v zadnjih {{months}} mesecih pred datumom vrednotenja ({{date}}).",
    selectionNoteCohortNone:
      "Od {{considered}} pregledanih poslov v radiju {{radius}} km ni bil noben primerljiv posel sklenjen v zadnjih {{months}} mesecih pred datumom vrednotenja ({{date}}), zato realizirane prodaje v oceno vrednosti niso vključene.",
    selectionNoteSizeBand:
      "Upoštevali smo posle s površino med {{min}} in {{max}} m².",
    selectionNoteNoSizeShort:
      "Površina te nepremičnine v GURS ni znana, zato poslov nismo izbrali po velikosti.",
    selectionNoteHistorical:
      "{{count}} starejših primerljivih poslov prikazujemo le kot zgodovinski kontekst (označeni kot starejši); v oceno niso vključeni.",
    selectionNoteExcluded:
      "Izločenih: {{count}}",
    selectionExclIneligible:
      "{{count}} ne ustreza merilom primerljivosti (npr. prodaja deleža, posel med povezanimi osebami)",
    selectionExclNotComparable:
      "{{count}} po velikosti, razmerju zemljišče/stavba ali ceni",
    selectionExclOutliers:
      "{{count}} statističnih osamelcev",
    selectionExclDate:
      "{{count}} brez veljavnega datuma ali podvojenih",
    evidence: {
      eyebrow: "Dokazi za oceno",
      title: "Najmočnejši primerljivi posli in pot do ocene",
      desc: "Kateri realizirani posli so tej nepremičnini najbolj podobni, v čem se razlikujejo in kako iz opazovanih cen nastane ocena.",
      headlinePriced: "Prikazujemo {{shown}} najbolj podobnih izmed {{priced}} poslov v oceni; oceno so določili vsi, ne le prikazani.",
      headlineThin: "Realiziranih prodaj iz zadnjih 24 mesecev je v oceni le {{priced}}: dokazi so skromni.",
      headlineHistorical: "V zadnjih 24 mesecih ni primerljive realizirane prodaje; starejši posli spodaj so le zgodovinski kontekst.",
      headlineNoSales: "V okolici ni primerljive realizirane prodaje.",
      headlineNoArea: "Informativne vrednosti nismo izračunali, ker površina nepremičnine v GURS ni znana.",
      headlineNoRecent: "Informativne vrednosti nismo izračunali: v zadnjih 24 mesecih ni primerljive realizirane prodaje in ni primerljivih oglasov.",
      headlineWithheld: "Informativne vrednosti nismo objavili: primerljivi posli so premalo številni ali preveč razpršeni za zanesljivo oceno.",
      headlineContextSuffix: "Starejši posli spodaj so le zgodovinski kontekst.",
      colSale: "Posel",
      colDate: "Datum",
      colDistance: "Oddaljenost",
      colArea: "Površina",
      colPrice: "Cena",
      colPricePerM2: "Cena/m²",
      colSimilarity: "Podobnost",
      sourceId: "ETN ID posla {{id}}",
      typeApartment: "stanovanje",
      typeHouse: "hiša",
      addressUnknown: "Naslov ni objavljen",
      atValuationDate: "na datum vrednotenja {{price}}",
      contextMarker: "starejši posel — le kontekst",
      yearOnly: "leto {{year}}",
      knownDifferences: "Znane razlike",
      dealNotes: "Posebnosti posla",
      areaBasis: "Osnova površine",
      areaBasisDwelling: "prodana neto tlorisna površina stanovanjske enote",
      areaBasisAllParts: "prodana površina vseh delov posla",
      diffSizeSimilar: "podobna površina ({{area}})",
      diffSizeLarger: "večja za {{pct}} ({{area}})",
      diffSizeSmaller: "manjša za {{pct}} ({{area}})",
      diffSizeUnknownSubject: "{{area}}; površina te nepremičnine ni znana",
      diffYearSame: "zgrajena istočasno ({{year}})",
      diffYearNewer: "novejša za {{years}} let ({{year}})",
      diffYearOlder: "starejša za {{years}} let ({{year}})",
      diffYearUnknown: "leto izgradnje ni znano",
      diffYearUnknownSubject: "zgrajena {{year}}; leto izgradnje te nepremičnine ni znano",
      diffLandSimilar: "podobno zemljišče ({{area}})",
      diffLandMore: "več zemljišča za {{pct}} ({{area}})",
      diffLandLess: "manj zemljišča za {{pct}} ({{area}})",
      diffLandUnknownSubject: "zemljišče {{area}}; zemljišče te nepremičnine ni znano",
      diffLandNone: "zemljišče v poslu ni evidentirano",
      flags: {
        ancillary_included: "cena vključuje garažo, parkirno mesto ali shrambo (njihova površina ni v m²)",
        outbuildings_included: "cena vključuje pomožne ali gospodarske objekte",
        minor_extra_land: "prodaja vključuje manjše dodatno zemljišče",
        shared_land: "zemljišče je prodano v solastniškem deležu",
        vat_included: "cena vključuje DDV",
        vat_rate_mixed: "cena vključuje DDV po različnih stopnjah",
        new_build: "novogradnja",
        voluntary_auction: "prodaja na prostovoljni dražbi",
        gurs_market_data_issue: "GURS: tržni posel z nepopolnimi podatki",
        gurs_unverified: "GURS posla še ni preveril",
      },
      priceAdjustment: "Prilagoditev cene",
      adjSize: "velikost {{pct}}",
      adjAge: "leto izgradnje {{pct}}",
      adjTotal: "skupaj {{pct}}",
      adjNone: "brez prilagoditve (velikost in leto izgradnje se ujemata ali nista znana)",
      setTitle: "Prikazani posli in celotna analiza.",
      setWeighting: "V povprečje ETN vstopijo vsi posli iz zadnjih {{months}} mesecev ({{priced}}), ne le prikazani, tehtani po površini (vsota cen / vsota m²).",
      setWeightsAsking: "Realizirane prodaje nosijo {{etn}} % ocene, oglaševane cene ({{listings}} oglasov) preostanek.",
      setWeightsOnly: "Realizirane prodaje nosijo {{etn}} % ocene.",
      setEtnZero: "V tej oceni realizirane prodaje nimajo teže.",
      setNone: "Nobena realizirana prodaja ni vstopila v oceno.",
      setAverages: "Povprečje prikazanih poslov je {{shown}}, vseh poslov v oceni ({{priced}}) pa {{all}}.",
      setExcluded: "Iz ocene je izločenih {{excluded}} od {{considered}} pregledanih poslov; razlogi so navedeni pri izboru poslov.",
      similarityMethod: "Podobnost (0–100) izračunamo iz oddaljenosti, razlike v neto tlorisni površini, razlike v letu izgradnje, starosti posla in, pri hišah, razlike v velikosti zemljišča. Neznan podatek šteje kot polovično neujemanje. Vrsta nepremičnine se ujema pri vseh poslih, ker so izbrani le posli iste vrste.",
      bridgeTitle: "Od opazovanih cen do ocene",
      legs: {
        etn: "Realizirane prodaje (ETN)",
        market: "Oglaševane cene",
        gurs: "Posplošena vrednost GURS",
      },
      weight: "utež {{pct}} %",
      observedEtn: "Opazovano: vsota cen / vsota m² vseh {{n}} poslov v oceni",
      observedMarket: "Opazovano: povprečna oglaševana cena {{n}} oglasov v analizi",
      observedGurs: "Opazovano: posplošena vrednost GURS / površina za izračun ocene",
      steps: {
        etn_time_index: "Časovna prilagoditev na datum vrednotenja {{pct}} (izmerjeno: lokalna letna sprememba cen iz istih poslov)",
        etn_uplift: "Zvišanje cen ETN {{pct}} (predpostavka modela, ni neodvisno preverjena)",
        asking_haircut_measured: "Znižanje oglaševanih cen {{pct}} (izmerjeno razmerje oglas/realizirana cena; verjetno zgornja meja)",
        asking_haircut_assumed: "Znižanje oglaševanih cen {{pct}} (predpostavka, manjša od izmerjene razlike)",
        gurs_uplift: "Zvišanje posplošene vrednosti GURS {{pct}} (predpostavka modela, ni neodvisno preverjena)",
        etn_comparable_adjustments: "Prilagoditev primerljivih poslov za razlike v velikosti in letu izgradnje {{pct}} (izmerjeno na evidentiranih poslih; prilagoditev vsakega posla je navedena pri poslu)",
        subject_position: "Nadstropje in dvigalo {{pct}} (uradni faktor lege GURS za to stanovanje; nadstropja primerljivih poslov niso evidentirana)",
      },
      statusMeasured: "izmerjeno",
      statusAssumed: "predpostavka",
      effectOnEstimate: "Vpliv na oceno: {{eur}}",
      contribution: "Prispevek k oceni: {{price}} × {{share}}",
      downweight: "Teža realiziranih prodaj je pomnožena z {{value}}, ker so usklajene oglaševane cene precej višje (predpostavka modela, ni neodvisno preverjena).",
      weightedPrice: "Tehtana cena na m²",
      roundedFrom: "zaokroženo s {{value}}",
      timesArea: "× {{label}} {{area}} = informativna vrednost",
      noSubjectAdjustments: "Za razlike med primerljivimi posli in to nepremičnino (velikost, starost, zemljišče, stanje, energijski razred, nadstropje) ocena ne uporablja prilagoditev: za nobeno od njih nimamo preverjenega lokalnega koeficienta. Te razlike so navedene, a niso ovrednotene.",
      subjectAdjustmentsSizeAge: "Razlike v velikosti in letu izgradnje so ovrednotene s koeficienti, izmerjenimi na evidentiranih poslih (manjša stanovanja dosegajo višjo ceno na m²); prilagoditev vsakega prikazanega posla je navedena pri poslu.",
      subjectAdjustmentsPosition: "Nadstropje in dvigalo upoštevamo z uradnim faktorjem lege GURS za to stanovanje.",
      subjectAdjustmentsRest: "Zemljišča, stanja in energijskega razreda ne vrednotimo, ker zanje nimamo izmerjenega koeficienta.",
      subjectAdjustmentsRestNoSizeAge: "Velikosti, starosti, zemljišča, stanja in energijskega razreda ne vrednotimo, ker zanje nimamo izmerjenega lokalnega koeficienta; razlike so navedene pri poslih.",
      rangeNote: "Razpon {{min}} – {{max}} je opisan v metodologiji.",
      mismatch: "Neujemanje:",
      driversTitle: "Kaj najbolj vpliva na oceno",
      driverSource: "{{label}}: {{pct}} % ocene — {{price}} po prilagoditvah, prispevek {{eur}}",
      driverStep: "{{step}}: {{eur}} na oceno",
      unpricedTitle: "Česar ocena ne vrednoti",
      unpricedTitleNoEstimate: "Česar primerjava s posli ne zajame",
      unpriced: {
        condition: "Stanje in obnove: ni podatka ne za to nepremičnino ne za primerljive posle, zato razlika ni ovrednotena. Obnovljena nepremičnina ali taka, ki potrebuje obnovo, lahko od ocene bistveno odstopa.",
        energy: "Energijski razred: v evidenci trga ni podatka za primerljive posle, zato razlika ni ovrednotena.",
        floor: "Nadstropje in dvigalo: v evidenci trga ni podatka, zato razlika ni ovrednotena.",
        floor_position: "Nadstropje in dvigalo: za primerljive posle v evidenci trga ni podatka; pri tej nepremičnini je upoštevan uradni faktor lege GURS, razlika do posameznega posla pa ni ovrednotena.",
        land: "Zemljišče: razlike v velikosti in rabi zemljišča so prikazane pri posameznih poslih, a niso ovrednotene.",
        land_unknown: "Zemljišče: velikost zemljišča te nepremičnine ni znana, zato primerjava zemljišč ni mogoča.",
        package_contents: "Vsebina posla: pri nekaterih poslih cena vključuje garažo, parkirno mesto ali pomožne objekte, katerih površina ni v m²; njihova vrednost ni odšteta.",
      },
      nextStepsTitle: "Kaj preveriti naslednje",
      nextSteps: {
        get_area: "Pridobite neto tlorisno površino dela stavbe (GURS kataster stavb, projektna dokumentacija ali prodajalec); brez nje ocene ni mogoče izračunati.",
        appraisal_no_recent_sales: "Za trenutno vrednost naročite cenitev pri sodnem cenilcu: v zadnjih 24 mesecih ni primerljive realizirane prodaje, cene starejših poslov pa niso današnja vrednost.",
        appraisal_withheld: "Za zanesljivo vrednost naročite cenitev pri sodnem cenilcu: primerljivih realiziranih prodaj je premalo ali so preveč razpršene.",
        thin_evidence: "Ocena sloni na zelo malo realiziranih prodajah; posamezen netipičen posel jo lahko močno premakne. Pred zavezujočo ponudbo pridobite dodatne primerjave ali cenitev.",
        no_recent_sales: "V zadnjih 24 mesecih ni primerljive realizirane prodaje; za trenutno raven cen se opirajte na cenitev ali preverjene dogovorjene cene v okolici.",
        inspect_condition: "Stanje, obnove in energijski razred preverite na ogledu in v energetski izkaznici — to so glavne razlike, ki jih ocena ne vrednoti.",
        size_spread: "Večina prikazanih poslov se po površini razlikuje za 20 % ali več; cena na m² je pri manjših enotah praviloma višja, pri večjih nižja.",
        house_parcels: "Preverite, katere parcele in pomožni objekti so vključeni v prodajo (zemljiška knjiga, katastrski načrt), in jih primerjajte s posli zgoraj.",
        etn_unweighted: "Realizirane prodaje v tej oceni nimajo teže (ocena sloni na oglaševanih cenah); pri prodajalcu ali agentu preverite dosežene cene primerljivih nepremičnin.",
      },
    },
    actionEyebrow: "Naslednji koraki",
    actionTitle: "Kaj preveriti pred podpisom",
    actionDesc:
      "Vrstni red je namenski: najprej tisto, česar za to nepremičnino nismo mogli preveriti, nato standardna preverjanja pri vsakem nakupu.",
    limitationsTitle: "Omejitve tega poročila",
    limitationsIntro: "Nekaterih podatkov v času izdelave ni bilo mogoče pridobiti ali preveriti. Spodaj je navedeno, kaj manjka, zakaj in kaj lahko storite. Ostali podatki so povzeti iz navedenih uradnih evidenc in oglasov, kot so bili ob izdelavi poročila; morebitnih napak v samih evidencah ni mogoče izključiti.",
    limitationsRecovery: "Kaj lahko storite:",
    qualityReviewNotice: "To poročilo pregledujemo, ker samodejna kontrola kakovosti ni potrdila vseh podatkov. Do konca pregleda številk ne uporabljajte za odločitve.",
    execTitle: "Izvršni povzetek",
    cadastralIdentity: { building: "Stavba", apartment: "Stanovanje", part: "Katastrski del", parcel: "Parcela", municipality: "k.o." },
    scopeWholeTitle: "Predmet ocene: celotna stavba",
    scopePartTitle: "Predmet ocene: posamezni del stavbe",
    scopeParts: "Vključeni evidentirani deli",
    scopeAreaParts: "Deli v površini za oceno",
    scopeWholeNote: "Če kupujete le en del hiše, ocene celotne stavbe ne uporabite zanj. Potrdite, kateri deli so predmet prodaje.",
    scopePartNote: "To je analiza navedenega dela, ne celotne stavbe. Potrdite, da se ujema z delom, ki ga kupujete.",
    execValue: "Informativna ocena vrednosti",
    execGursOnlyValue: "Orientacija na podlagi GURS",
    execRangePrefix: "Orientacijski modelni razpon",
    execRangeNote: "Razpon ne zagotavlja, da bo prodajna cena v teh mejah, in ni pogajalski razpon.",
    execInterpretations: {
      high: "Oceno podpirajo primerljive realizirane prodaje. Ne določa najvišje smiselne ponudbe; odločitev je odvisna tudi od dejanskega stanja, stroškov in vašega proračuna.",
      medium: "Ocena temelji na razpoložljivih virih z navedenimi omejitvami. Pred zavezujočo ponudbo preverite primerljivost, dejansko stanje in stroške; znesek ni zgornja meja ponudbe.",
      low: "Ocena je predvsem orientacijska. Pred zavezujočo ponudbo priporočamo dodatno preverbo.",
      gurs_only: "Znesek izhaja samo iz GURS s predpostavljeno modelno prilagoditvijo. Uporabljivih primerljivih prodaj ali oglasov ni, zato služi le kot orientacija. Pred zavezujočo ponudbo pridobite neodvisno cenitev.",
      limits: "Razlogi za omejeno zanesljivost:",
    },
    execCeiling: "Zaokrožena orientacijska vrednost",
    execCeilingNote: "Zaokroženo izhodišče te analize. Razpon ocene prikazuje negotovost in ni pogajalski razpon.",
    execTopRisk: "Glavno tveganje",
    execNoRisk: "Ni odprtih opozoril",
    execDisclaimer:
      "Informativno poročilo za pametnejše odločanje — ne nadomešča uradne cenitve.",
    riskEyebrow: "Preverjeno stanje",
    propertyChecks: propertyChecksSl,
    supportingDocuments: supportingDocumentsSl,
    riskTitle: "Kaj je preverjeno in kaj ne",
    riskDesc:
      "Ta analiza temelji na javnih evidencah. Spodaj je izrecno navedeno, kaj smo lahko preverili, česa nismo in kaj je smiselno preveriti pred podpisom.",
    appraisalTitle: "Pred zavezujočo ponudbo",
    appraisalBeforeOffer: "pred ponudbo",
    confidenceTitle: "Zanesljivost ocene",
    confidenceHigh: "Visoka",
    confidenceMedium: "Zmerna",
    confidenceLow: "Nizka",
    confidenceHighNote:
      "V okolici je dovolj primerljivih realiziranih poslov in oglasov, da je ocena trdno podprta. Kupec ima zanesljivo izhodišče za pogajanja, prodajalec pa za določitev cene.",
    confidenceMediumNote:
      "Ocena temelji na razpoložljivih virih, vendar je prostor za odstopanje. Uporabite jo kot orientacijo in ne kot točno številko — pri pogajanjih računajte na širši razpon.",
    confidenceLowNote:
      "Ocena ima omejitve v podatkovnih ali tržnih podlagah in je predvsem orientacijska. Razlogi in uporabljeni podatki so navedeni spodaj; pred pomembno odločitvijo priporočamo dodatno preverbo oziroma neodvisno cenitev.",
    confidenceLimits: {
      few_comparable_sales: "Malo primerljivih realiziranih poslov",
      wide_comparable_spread: "Velika razpršenost cen primerljivih poslov",
      very_wide_comparable_spread: "Zelo velika razpršenost cen primerljivih poslov",
      stale_comparable_sales: "Starejši primerljivi posli",
      very_stale_comparable_sales: "Zelo stari primerljivi posli",
      sources_disagree: "Razhajanje cen med uporabljenimi viri",
      sources_disagree_strongly: "Veliko razhajanje cen med uporabljenimi viri",
      house_segment: "Večja raznolikost hiš glede stanja, zemljišča in starosti",
      subject_area_unconfirmed: "Površina ni potrjena z več uporabljenimi viri",
      subject_data_limited: "Omejitve podatkov o predmetu ali površini vrednotenja",
      asking_evidence_weak: "Širši zajem ali omejena primerljivost oglasov",
      gurs_only: "Ocena izhaja le iz modelne reference GURS",
    },
    confidenceComparables: "Primerljivi realizirani posli",
    confidenceListings: "Primerljivi aktivni oglasi",
    confidenceListingQuality: "Kakovost dokazov iz oglasov",
    confidenceDispersion: "Razpršenost cen primerljivih poslov",
    confidenceDataAge: "Starost najnovejšega posla",
    confidenceMonths: "{{count}} mes.",
    avgPrice: "Povprečna cena",
    medianPrice: "Mediana cene",
    minPrice: "Najnižja cena",
    maxPrice: "Najvišja cena",
    pricePerM2: "Cena na m²",
    propertyValue: "Vrednost nepremičnine",
    marketAverage: "Oglaševane cene, preračunane na to površino",
    askingHaircut: "Upoštevan popust od oglaševane cene",
    differenceFromAsking: "Razlika do oglaševanih cen na m²",
    pricePercentile: "Cenovni percentil",
    marketSegment: "Cenovna skupina med oglasi",
    positionValueLabel: "Primerjani izračun",
    marketSegmentLabels: {"budget": "Spodnja četrtina", "average": "Med 25. in 50. percentilom", "premium": "Med 50. in 75. percentilom", "luxury": "Zgornja četrtina"},
    avgSize: "Povprečna velikost",
    avgYearBuilt: "Povprečno leto izgradnje",
    newerProperties: "Novejše nepremičnine",
    olderProperties: "Starejše nepremičnine",
    askingVsSold: "Razlika ponudba/prodaja",
    negotiationPotential: "Potencial za pogajanje",
    negotiationNotAssessed: "Ni ocenjen. Razlika med oglaševanimi in prodajnimi cenami ne določa popusta za to nepremičnino.",
    marketLiquidity: "Likvidnost trga",
    gursGeneralized: "GURS posplošena vrednost",
    landGursValue: "GURS vrednost zemljišča",
    analyzedDeals: "Analiziranih poslov",
    avgEtnPrice: "Povprečna cena",
    priceTrend: "Trend cen",
    closestDeal: "Najbližji posel",
    year: "Leto",
    transactions: "Št. transakcij",
    avgPriceM2: "Povp. cena/m²",
    medianPriceM2: "Mediana cene/m²",
    change: "Sprememba",
    overallGrowth: "Skupna rast",
    annualizedGrowth: "Letna rast (CAGR)",
    comparableArea: "Primerljiva površina (neto, pomožni prostori uteženi)",
    comparableAreaShort: "Primerljiva površina",
    valuedOnArea: "{{price}} × primerljiva površina {{area}}",
    comparableAreaFlat: "Primerljiva površina = (uporabna {{usable}} + {{weight}} × pomožni prostori {{ancillary}}) / {{ratio}}{{unallocated}} = {{area}} (neto tlorisna površina {{net}}).",
    comparableAreaUnallocated: " + nerazporejeni prostori {{area}}",
    comparableAreaHouse: "Primerljiva površina = neto {{net}} − pomožni prostori {{ancillary}} + {{weight}} × {{ancillary}} = {{area}}: terase in kleti štejejo z manjšo utežjo kot povprečni m² primerljivih hiš.",
    comparableAreaHouseNoAncillary: "Primerljiva površina je enaka neto tlorisni površini {{net}} (GURS ne navaja teras ali kleti).",
    comparableAreaWhy: "Cene primerljivih poslov so na m² neto tlorisne površine, ki vključuje tudi njihove kleti in balkone; pomožne prostore zato na obeh straneh vrednotimo z isto utežjo.",
    growthCaveatNote: "‡ Sprememba za več kot 25 % v enem letu ({{years}}) je pri lokalnem vzorcu prodaj najverjetneje posledica drugačne sestave prodanih nepremičnin (velikost, starost, novogradnje), ne dejanskega gibanja cen.",
    anomalyNote:
      "* Leto z zelo malo posli in ceno, ki močno odstopa od okoliškega povprečja — najpogosteje gre za en sam neznačilen posel (npr. prodaja deleža, posel med povezanimi osebami ali nepremičnina druge kategorije). Posel prikazujemo, v izračun rasti pa ga ne vključimo.",
    address: "Naslov",
    price: "Cena",
    distance: "Oddaljenost",
    dealDate: "Datum posla",
    indexedPricePerM2: "Na dan vrednotenja",
    indexedPriceNote:
      "Na dan vrednotenja {{date}}: realizirana cena, preračunana na raven ob tem datumu po ocenjeni letni spremembi {{rate}} za to okolico. Starejših surovih prodajnih cen ni mogoče neposredno primerjati z oglaševanimi cenami iz časa poročila. Poslov, starejših od petih let na dan vrednotenja, ne indeksiramo. † označuje starejši posel, ki ni vključen v oceno.",
    adDescription: "Opis",
    adPriceLevel: "Raven cene",
    adPriceBelow: "Pod ravnjo oglasov",
    adPriceWithin: "V ravni oglasov",
    adPriceAbove: "Nad ravnjo oglasov",
    adLocation: "Lokacija",
    link: "Povezava",
    openAd: "Odpri oglas",
    na: "N/A",
    paginationPrevious: "Prejšnja",
    paginationNext: "Naslednja",
    paginationShowing: "Prikaz {{from}}–{{to}} od {{total}}",
    filtersTitle: "Filtri",
    filterMin: "Min",
    filterMax: "Maks",
    filtersClear: "Počisti",
    mapSubject: "Obravnavana nepremičnina",
    mapComparablesTitle: "Primerljive prodaje na zemljevidu",
    share: {
      button: "Deli",
      title: "Deli poročilo",
      description: "Kdorkoli s to povezavo lahko vidi poročilo. Prijava ni potrebna.",
      notCompleted: "Poročilo lahko delite, ko je izdelano.",
      generate: "Ustvari povezavo",
      generating: "Ustvarjanje…",
      linkLabel: "Javna povezava",
      copy: "Kopiraj",
      copied: "Kopirano!",
      revoke: "Prekliči dostop",
      revoking: "Preklicevanje…",
      notShared: "To poročilo še ni deljeno.",
      error: "Prišlo je do napake. Poskusite znova.",
    },
    sharedCta: "Ustvarite svoje poročilo",
    sharedClosingTitle: "Preverite še eno nepremičnino",
    sharedClosingText:
      "To poročilo je nekdo pripravil za konkreten naslov. Enako preverbo lahko naredite za katerikoli naslov v Sloveniji — prvo poročilo je brezplačno.",
    sharedClosingCta: "Preverite svojo nepremičnino",
    sharedUnavailableTitle: "Poročilo ni na voljo",
    sharedUnavailableText: "Ta povezava do poročila ni več na voljo.",
    intel: {
      eyebrow: "Lokalni trg oglasov",
      title: "Tržna inteligenca okolice",
      desc: "Analiza aktivnih oglasov primerljivih nepremičnin v okolici (nepremicnine.net).",
      sampleNote: "Na podlagi {{count}} aktivnih oglasov ({{locality}}).",
      sampleNoteAsOf: "Na podlagi {{count}} aktivnih oglasov ({{locality}}), stanje ob zajemu {{date}}.",
      medianAsking: "Mediana oglaševane cene",
      askingRange: "Razpon (P25–P75)",
      yourValue: "Vaša ocenjena vrednost",
      percentile: "Položaj med oglasi",
      pricingBelow: "Vaša vrednost na m² je pod večino lokalnih oglaševanih cen.",
      pricingInline: "Vaša vrednost je skladna z lokalnimi oglaševanimi cenami.",
      pricingAbove: "Vaša vrednost na m² je nad večino lokalnih oglaševanih cen.",
      newBuildShare: "Delež novogradenj",
      priceDrops: "Znižanja oglaševanih cen",
      dropsDetail: "{{share}} oglasov, povp. {{avg}}",
      observedAge: "Opazovana starost oglasov (mediana)",
      observedAgeValue: "{{days}} dni",
      observedAgeLowerBound: "vsaj {{days}} dni",
      delisted: "Umaknjeni oglasi (zadnjih 30 dni opazovanja)",
      delistedDetail: "{{delisted}} umaknjenih / {{active}} aktivnih",
      activityOutage: "Zajem oglasov je prekinjen od {{date}}, zato starosti oglasov in umikov ne prikazujemo; cene oglasov kažejo stanje ob zadnjem zajemu.",
      activityShallow: "Arhiv oglasov še nima dovolj dolge neprekinjene zgodovine, zato starosti oglasov in umikov ne prikazujemo.",
      activityNote: "Opazovana starost je čas med prvim in zadnjim zajemom oglasa v našem arhivu, ne datum prve objave. Umik oglasa ne pomeni prodaje. Hitrosti prodaje ne ocenjujemo, ker oglasov ne moremo povezati z evidentiranimi prodajami.",
    },
  },
  creditHistory: {
    title: "Zgodovina kreditov",
    filterPlaceholder: "Filtriraj po vrsti",
    filterAll: "Vse transakcije",
    filterPurchase: "Nakupi",
    filterUsage: "Poraba",
    filterExpiring: "Potečejo kmalu",
    date: "Datum",
    noResults: "Ni rezultatov.",
    noResultsHint: "Poskusite z drugačnimi filtri.",
    noTransactions: "Ni transakcij.",
    noTransactionsHint: "Vaše transakcije se bodo prikazale tukaj.",
    expired: "Poteklo",
    expiresIn: "Poteče čez {{days}} dni",
    validUntil: "Veljavno do",
  },
  creditBalance: {
    title: "Moji krediti",
    available: "Razpoložljivi krediti",
    refresh: "Osveži stanje",
  },
  embeddedCheckout: {
    loginRequired: "Za plačilo se morate prijaviti.",
    createError: "Napaka pri ustvarjanju plačila. Prosimo, poskusite znova.",
    preparing: "Pripravljamo plačilo...",
    tryAgain: "Poskusi znova",
    successTitle: "Plačilo uspešno!",
    successDesc: "Krediti so bili dodani na vaš račun.",
  },
  checkoutModal: {
    eyebrow: "Plačilo",
    purchase: "Nakup: {{name}}",
    purchaseCredits: "Nakup {{count}} kreditov",
  },
  ratePage: {
    backHome: "Nazaj na domačo stran",
  },
  userRating: {
    title: "Kako bi ocenili našo storitev?",
    subtitle: "Vaša povratna informacija nam pomaga izboljšati storitev",
    rateAria: "Oceni {{star}} od 5",
    saveError: "Ocene ni bilo mogoče shraniti.",
    thanksToast: "Hvala!",
    thanksToastDesc: "Vaša ocena je bila uspešno shranjena.",
    thanks: "Hvala za vašo oceno!",
  },
  cookieConsent: {
    title: "Spoštujemo vašo zasebnost",
    description:
      "Nujno potrebne piškotke uporabljamo za delovanje spletnega mesta. Analitične in trženjske piškotke naložimo samo z vašo privolitvijo. Izbiro lahko kadar koli spremenite.",
    cookiePolicyLink: "Politika piškotkov",
    privacyPolicyLink: "Politika zasebnosti",
    necessaryTitle: "Nujno potrebni",
    necessaryDesc: "Prijava, varnost in izvedba plačila. Teh ni mogoče izklopiti.",
    analyticsTitle: "Analitični",
    analyticsDesc: "Merjenje obiska in uporabe strani, da lahko storitev izboljšujemo.",
    marketingTitle: "Trženjski",
    marketingDesc: "Merjenje uspešnosti oglasov in prikaz ustreznejših oglasov.",
    acceptAll: "Sprejmi vse",
    rejectAll: "Zavrni nenujne",
    customize: "Nastavitve",
    saveSelection: "Shrani izbiro",
  },
  withdrawal: {
    heading: "Pred plačilom: takojšnja izvedba",
    explainer:
      "Poročilo je digitalna vsebina, ki jo izdelamo takoj po plačilu. Zakon o varstvu potrošnikov (135. člen ZVPot-1) zahteva, da nas za takojšen začetek izvedbe izrecno pooblastite in potrdite, da s tem za izdelano poročilo izgubite 14-dnevno pravico do odstopa. Neporabljeni krediti ostanejo vračljivi v 14 dneh.",
    consentLabel:
      "Soglašam, da se izvedba začne takoj, in potrjujem, da s popolno izvedbo izgubim pravico do odstopa od pogodbe za izdelano poročilo.",
    termsPrefix: "Z nadaljevanjem sprejemate:",
  },
  legal: legalSl,
} as const;

// `sl` is `as const` so its shape is captured exactly, but the translation
// contract should accept ANY string per key (other locales have different
// text). Widen literal values to their primitives while preserving the key
// structure — this keeps key-completeness checking for en/de/ru without
// forcing every value to equal the Slovenian literal (which produced ~1675
// phantom type errors).
type Widen<T> = T extends string
  ? string
  : T extends number
    ? number
    : T extends boolean
      ? boolean
      : T extends readonly (infer U)[]
        ? readonly Widen<U>[]
        : { [K in keyof T]: Widen<T[K]> };

export type Translations = Widen<typeof sl>;
